export default {"src":"/_next/static/media/32.a8367767.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};